import { render, staticRenderFns } from "./IconShieldExclamationOutline.vue?vue&type=template&id=b4885c3a"
import script from "./IconShieldExclamationOutline.vue?vue&type=script&lang=js"
export * from "./IconShieldExclamationOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports